import { render, staticRenderFns } from "./Feedbackpage.vue?vue&type=template&id=ef203946&scoped=true&"
import script from "./Feedbackpage.vue?vue&type=script&lang=js&"
export * from "./Feedbackpage.vue?vue&type=script&lang=js&"
import style0 from "./Feedbackpage.vue?vue&type=style&index=0&id=ef203946&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef203946",
  null
  
)

export default component.exports